import { CODE_PENALTY_RUB, pickCards } from "../../utils/pickCards";
import { useStoreCards } from "../nintendoDeals/useNintendoCards";

export const PS_STORE_ID = "playstation";

/**
 * Регион скидок → регионы карт PSN в каталоге магазина и валюта цен.
 * Один заказ — один регион карт, поэтому для США план считается по каждому отдельно.
 */
export const PS_CARD_REGIONS = {
  us: { currency: "USD", cardRegions: ["api", "us"] },
  pl: { currency: "PLN", cardRegions: ["pln"] },
};

export const usePsCards = () => useStoreCards(PS_STORE_ID);

/** Каталоги карт для региона скидок (только с номиналами). */
export function psCatalogs(region, cardsFor) {
  const config = PS_CARD_REGIONS[region];
  if (!config) return [];
  return config.cardRegions
    .map((cardRegion) => cardsFor(cardRegion))
    .filter((catalog) => catalog?.denominations.length);
}

/** Самый выгодный набор карт среди каталогов: { plan, catalog } или null. */
export function bestPsPlan(need, catalogs) {
  let best = null;
  catalogs.forEach((catalog) => {
    const plan = pickCards(need, catalog.denominations);
    if (!plan) return;
    const cost = plan.rub + CODE_PENALTY_RUB * plan.codes;
    if (!best || cost < best.cost) best = { plan, catalog, cost };
  });
  return best && { plan: best.plan, catalog: best.catalog };
}
